import dayjs from 'dayjs'

export function formatDate(date, pattern = 'MMM DD, YYYY') {
  return date ? dayjs(date).format(pattern) : ''
}

export function displayName(firstName, lastName) {
  return [firstName, lastName].filter(Boolean).join(' ')
}
